import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { defaultImagePng } from 'projects/app-default/src/app/icms.config';

export interface IPageComponentImageData {
    image: string;
    ratio: string;
    cta_link?: string;
}

@Component({
    selector: 'page-component-image',
    templateUrl: './image.html',
    standalone: true,
    imports: [HrefComponent, NgClass, ImageModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentImageComponent>({
    id: 'image',
    name: 'Image',
    image: '/common/cms/image-component.png',
    tags: ['image', 'big', 'banner'],
    isAdvanced: true,
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        <NICmsContentField.IChoiceField>{
            key: 'ratio',
            type: NICmsContentField.EFieldType.choice,
            title: 'Ratio',
            options: RatioOptions,
            description: 'Proportions width x height',
            default: 'ratio-2-1'
        },
        {
            key: 'image',
            type: NICmsContentField.EFieldType.image,
            title: 'Image',
            default: defaultImagePng,
            required: true
        },
        {
            key: 'cta_link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link'
        }
    ]
})
export class PageComponentImageComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentImageData;
}
